import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import Form from 'component/utils/Form'
import Input from 'component/utils/Input'
import MagnifierAlt from 'images/magnifier-alt.svg'
import ClearSVG from 'component/svgComponents/clear'

const FIELDS = ['dsMission']

const FilterForm = ({ fields, submit, translate}) => {
  const [text,setText] = useState("")
  const [withValueEffect, setWithValueEffect] = useState("")
  const [enterMode, setEnterMode] = useState(false)

  const beforeSubmit = (event) => {
    event.preventDefault()
    if(text !== "") setEnterMode(true)
    else setEnterMode(false)
    submit(text.replace(/\s+/g, ' ').trim(), true)
  }


  useEffect(() => {
    if(enterMode) setWithValueEffect("search-value-effect")
    else setWithValueEffect("")
  }, [enterMode])


  return (
    <form onSubmit={beforeSubmit}>
      <Col className={`mission-block-search ${withValueEffect}`} >
        <Field {...fields.text} ignoreActiveClass>
          <Input
            value={text}
            onChange={(e) => setText(e.target.value)}
            className='mission-block-mission-input pictogram-search'
            placeholder={translate(
              'Pesquisar por nome da missão'
            )}
          />
        </Field>
      </Col>

      <button style={{ background: 'none', border: 'none' }}>
        <img src={MagnifierAlt} className='mission-block-mission-magnifier' />
      </button>
      
      {text.length > 0 && <ClearSVG className="mission-block-mission-clear" onClick={() => {
        if(!text) return
        setText("")
        setEnterMode(false)
        submit(null, true)
      }} />
    }
    </form>
  )
}

FilterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired
}

export default Form({ fields: FIELDS })(FilterForm)

export { FilterForm }
